module.exports = __webpack_public_path__ + "img/territorio.f48772c4.svg";